import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import usageTracker from 'flow-doctor-lib/usageTracker';
import { getEnrollmentHistoryLogsUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentChecksEmptyState = ({
  status,
  portalId,
  flowId,
  objectId,
  timelineItem
}) => {
  if (status === 'PASSED') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.passed.emptyState"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.failed.emptyState.noIssues"
      })
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.failed.emptyState.viewLogs_jsx",
      elements: {
        Link: UILink
      },
      options: {
        external: true,
        href: getEnrollmentHistoryLogsUrl({
          portalId,
          objectId,
          flowId,
          timestamp: timelineItem.timestamp
        }),
        onClick: () => usageTracker.track('pageAction', {
          actionType: 'CLICK_VIEW_ENROLLMENT_HISTORY_LOGS'
        })
      }
    })]
  });
};
export default EnrollmentChecksEmptyState;